import React from "react";
import BaseButton from "./basebutton";

export default BaseButton;
